module.exports = __webpack_public_path__ + "img/initial-status.c4ad3390.svg";